import React from "react";

const WifiMetadataBdDescription = ({ content }) => {

  const comment = content.description || "";
  const firstLine = comment.slice(0, 50);
  const rest = comment.slice(50);

   const dateValue = new Date(content.createDate);
    const formattedDate = dateValue.toLocaleString("ru-RU", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    }).replace(",", ""); 

  return (
    <div className="divСommunicationsDrawer" 
          style={{ border: '1px solid #ffea97ff', padding: '10px', fontSize: '14px', boxShadow: "0px 0px 6px 0px #000000ff",
                    background: "linear-gradient(to bottom,  #292929ff, #353535ff)"
          }}
     >  
        
    <label style={{ color: "#ffea97ff", marginBottom: "2px", textShadow: "1px 1px 2px #000000ff", fontSize: '18px' }}>Метаданные</label>
      <hr className='hr-gradient' style={{marginBottom: '5px'}}/>

    <div className="infoCard" style={{ display: "block", boxShadow: "0px 0px 6px 0px #000000ff" }}>
        <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Внес:</span> <span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.authorId}</span></div>
        <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Дата добавления:</span> <span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{formattedDate}</span></div>
        {/* <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Комментарий:</span>{" "}<span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.description}</span></div> */}
       <div>
        <span style={{ color: "#181818ff", fontWeight: "bold" }}>
          Комментарий:
        </span>{" "}
        <span
          style={{
            display: "inline-block",
            maxWidth: "30ch",          // максимум ~50 символов в строке
            whiteSpace: "normal",      // разрешаем перенос
            wordBreak: "break-word",
            textShadow: "1px 1px 2px #000000ff",
            color: "#f0f0f0ff",
            verticalAlign: "top"
          }}
        >
          {content.description}
        </span>
      </div>
    </div>

     
     
     
      
      
    
    
      
    </div>
  );
};

export default WifiMetadataBdDescription;